import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { JSX } from 'react'
import {
  IntercomIcon,
  SevenroomsIcon,
} from '../components/third-party/icons/Icons'

type ThirdPartyName = 'sevenrooms' | 'intercom'
export const thirdParties: Record<ThirdPartyName, ThirdParty> = {
  sevenrooms: {
    id: 1,
    slug: 'sevenrooms',
    name: 'Sevenrooms',
    color: '#000',
    icon: SevenroomsIcon,
  },
  intercom: {
    id: 2,
    slug: 'intercom',
    name: 'Intercom',
    color: '#1F8DED',
    icon: IntercomIcon,
  },
}

export interface ThirdParty extends SBModel {
  slug: ThirdPartyName
  name: string
  website?: string
  color: string
  icon?: (props: {
    width?: number
    height?: number
    color?: string
  }) => JSX.Element
}

export interface ThirdPartyProfile {
  thirdParty: ThirdPartyName
  id?: string | number
  link?: string
}
